import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue')
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'welcome',
        name: 'Welcome',
        component: () => import('@/views/welcome.vue'),
        meta: { title: '欢迎页' }
      },
      {
        path: 'message',
        name: 'Message',
        component: () => import('@/views/message/index.vue'),
        meta: { title: '消息中心' }
      },
      {
        path: 'approvals',
        name: 'Approvals',
        component: () => import('@/views/approvals/index.vue'),
        meta: { title: '审批中心' }
      },
      {
        path: 'approvals/:type',
        name: 'ApprovalsByType',
        component: () => import('@/views/approvals/index.vue'),
        meta: { title: '审批列表' }
      },
      {
        path: 'approval-detail/:id',
        name: 'ApprovalDetail',
        component: () => import('@/views/approvals/detail.vue'),
        meta: { title: '审批详情' }
      },
      {
        path: 'more-actions',
        name: 'MoreActions',
        component: () => import('@/views/MoreActions.vue'),
        meta: { title: '更多操作' }
      },
      {
        path: 'cc_reports',
        name: 'CcReports',
        component: () => import('@/views/cc_reports.vue'),
        meta: { title: '抄送给我的报告' }
      },
      {
        path: 'cc_reports/:id',
        name: 'CcReportsDetail',
        component: () => import('@/views/cc_reports.vue'),
        meta: { title: '抄送给我的报告详情' }
      },
      {
        path: "announcement_list",
        name: "AnnouncementList",
        component: () => import("@/views/notice/announcement_list.vue"),
        meta: { title: "通知公告" }
      },
      {
        path: "announcement_detail/:id",
        name: "AnnouncementDetail",
        component: () => import("@/views/notice/announcement_detail.vue"),
        meta: { title: "公告详情" }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/users',
    meta: { title: '系统管理' },
    children: [
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/views/system/users.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'roles',
        name: 'Roles',
        component: () => import('@/views/system/roles.vue'),
        meta: { title: '角色管理' }
      },
      {
        path: 'menu',
        name: 'Menu',
        component: () => import('@/views/system/menu.vue'),
        meta: { title: '菜单管理' }
      },
      {
        path: 'flow_category',
        name: 'flow_category',
        component: () => import('@/views/system/flow_category.vue'),
        meta: { title: '审批类型' }
      },
      {
        path: 'flow_config',
        name: 'flow_config',
        component: () => import('@/views/system/flow_config.vue'),
        meta: { title: '审批流程' }
      },
      {
        path: 'node',
        name: 'node',
        component: () => import('@/views/system/node.vue'),
        meta: { title: '节点管理' }
      },
      {
        path: 'dictionary',
        name: 'dictionary',
        component: () => import('@/views/system/dictionary.vue'),
        meta: { title: '字典管理' }
      }
    ]
  },
  {
    path: '/statistics',
    component: Layout,
    redirect: '/statistics/visits',
    meta: { title: '统计分析' },
    children: [
      {
        path: 'visits',
        name: 'Visits',
        component: () => import('@/views/statistics/visits.vue'),
        meta: { title: '访问统计' }
      },
      {
        path: 'sales',
        name: 'Sales',
        component: () => import('@/views/statistics/sales.vue'),
        meta: { title: '销售统计' }
      }
    ]
  },
  {
    path: '/hr',
    component: Layout,
    redirect: '/hr/department',
    meta: { title: '人事' },
    children: [
      {
        path: 'department',
        name: 'department',
        component: () => import('@/views/hr/department.vue'),
        meta: { title: '部门架构' }
      },
       {
        path: 'employee',
        name: 'employee',
        component: () => import('@/views/hr/employee.vue'),
        meta: { title: '企业员工' }
      },
      {
        path: 'recruitment',
        name: 'recruitment',
        component: () => import('@/views/hr/recruitment.vue'),
        meta: { title: '招聘需求' }
      },
      {
        path: 'regularization',
        name: 'regularization',
        component: () => import('@/views/hr/regularization.vue'),
        meta: { title: '转正' }
      },
      {
        path: 'hr_employee',
        name: 'hr_employee',
        component: () => import('@/views/hr/hr_employee.vue'),
        meta: { title: '入职申请' }
      },

    ]
  },
  {
    path: '/administrative',
    component: Layout,
    redirect: '/administrative/leave',
    meta: { title: '行政' },
    children: [
      {
        path: 'leave',
        name: 'leave',
        component: () => import('@/views/administrative/leave.vue'),
        meta: { title: '请假申请' }
      },
      {
        path: 'trip',
        name: 'trip',
        component: () => import('@/views/administrative/trip.vue'),
        meta: { title: '出差' }
      },
      {
        path: 'vehicle',
        name: 'vehicle',
        component: () => import('@/views/administrative/vehicle.vue'),
        meta: { title: '用车' }
      },
      {
        path: 'seal',
        name: 'seal',
        component: () => import('@/views/administrative/seal.vue'),
        meta: { title: '用印' }
      },
      {
        path: 'attendance_config_list',
        name: 'attendance_config_list',
        component: () => import('@/views/administrative/attendance_config_list.vue'),
        meta: { title: '考勤组' }
      },
      {
        path: 'attendance_config',
        name: 'attendance_config',
        component: () => import('@/views/administrative/attendance_config.vue'),
        meta: { title: '考勤配置' }
      },
      {
        path: 'general',
        name: 'general',
        component: () => import('@/views/administrative/general.vue'),
        meta: { title: '通用申请' }
      }

    ]
  },
  {
    path: '/finance',
    component: Layout,
    redirect: '/finance/reimbursement',
    meta: { title: '报销' },
    children: [
      {
        path: 'reimbursement',
        name: 'reimbursement',
        component: () => import('@/views/finance/reimbursement.vue'),
        meta: { title: '报销' }
      },
      {
        path: 'loan',
        name: 'loan',
        component: () => import('@/views/finance/loan.vue'),
        meta: { title: '借款' }
      },
      {
        path: 'repayment',
        name: 'repayment',
        component: () => import('@/views/finance/repayment.vue'),
        meta: { title: '还款' }
      },
      {
        path: 'invoice',
        name: 'invoice',
        component: () => import('@/views/finance/invoice.vue'),
        meta: { title: '开票' }
      },
      {
        path: 'payment',
        name: 'payment',
        component: () => import('@/views/finance/payment.vue'),
        meta: { title: '付款' }
      }

    ]
  },
  {
    path: '/notice',
    component: Layout,
    redirect: '/notice/category',
    meta: { title: '公告分类' },
    children: [
      {
        path: 'category',
        name: 'category',
        component: () => import('@/views/notice/category.vue'),
        meta: { title: '公告分类' }
      },
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/notice/list.vue'),
        meta: { title: '公告列表' }
      }
    ]
  },
  {
    path: '/market',
    component: Layout,
    redirect: '/market/customer',
    meta: { title: '客户' },
    children: [
      {
        path: 'customer',
        name: 'customer',
        component: () => import('@/views/market/customer.vue'),
        meta: { title: '客户' }
      },
      {
        path: 'sales_contract',
        name: 'sales_contract',
        component: () => import('@/views/market/sales_contract.vue'),
        meta: { title: '销售合同' }
      },
      {
        path: 'customer_invoice',
        name: 'customer_invoice',
        component: () => import('@/views/market/customer_invoice.vue'),
        meta: { title: '客户开票信息' }
      }
    ]
  },
  {
    path: '/purchase',
    component: Layout,
    redirect: '/purchase/suppliers',
    meta: { title: '供应商' },
    children: [
      {
        path: 'suppliers',
        name: 'suppliers',
        component: () => import('@/views/purchase/suppliers.vue'),
        meta: { title: '供应商' }
      },
      {
        path: 'application',
        name: 'application',
        component: () => import('@/views/purchase/application.vue'),
        meta: { title: '采购申请' }
      }
    ]
  },
  {
    path: '/report',
    component: Layout,
    redirect: '/report/report_list',
    meta: { title: '报告管理' },
    children: [
      {
        path: 'report_list',
        name: 'ReportList',
        component: () => import('@/views/report/report_list.vue'),
        meta: { title: '报告列表' }
      },
      {
        path: 'report_edit',
        name: 'ReportEdit',
        component: () => import('@/views/report/report_edit.vue'),
        meta: { title: '报告编辑' }
      },
      // {
      //   path: 'report_statistics',
      //   name: 'ReportStatistics',
      //   component: () => import('@/views/report/report_statistics.vue'),
      //   meta: { title: '报告统计' }
      // },
      {
        path: 'template_list',
        name: 'ReportTemplateList',
        component: () => import('@/views/report/template_list.vue'),
        meta: { title: '模板管理' }
      },
      {
        path: 'template_edit',
        name: 'ReportTemplateEdit',
        component: () => import('@/views/report/template_edit.vue'),
        meta: { title: '模板编辑' }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || 'OA办公系统'
  
  // 不需要登录验证的路由
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const token = localStorage.getItem('token');
  
  // 判断是否需要登录权限
  if (authRequired && !token) {
    // 未登录，跳转到登录页面
    return next('/login');
  }
  
  // 已登录，正常跳转
  next();
})

export default router 